import { Component, OnInit } from '@angular/core';
import { ToastService } from 'core/services';

@Component({
  selector: 'lms-roleplay-subscription-list',
  templateUrl: './roleplay-subscription-list.component.html',
  styleUrl: './roleplay-subscription-list.component.scss'
})
export class RoleplaySubscriptionListComponent implements OnInit {
  constructor(private toastService: ToastService) {}

  public ngOnInit(): void {}

  public saveSubscription(event: any) {
    if (event?.subscription) {
      this.toastService.showOk('', 3000, false);
    }
  }
}
